import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const ArbitrumNovaLogoCircle = t0 => {
  const $ = _c(17);
  let className;
  let rest;
  let square;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      square,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = square;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    square = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[5] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = square ? 0 : 12;
  let t4;
  if ($[7] !== t3) {
    t4 = <rect fill="#2D374B" height={24} rx={t3} width={24} />;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M9.293 6H7.674a.266.266 0 0 0-.25.175L3.168 17.822a.133.133 0 0 0 .125.178h1.62c.111 0 .21-.07.25-.175L9.417 6.178A.133.133 0 0 0 9.293 6Zm1.97 4.88a.133.133 0 0 0-.25 0l-.84 2.298a.265.265 0 0 0 0 .182l1.632 4.465a.266.266 0 0 0 .25.175h1.62a.133.133 0 0 0 .125-.178l-2.537-6.942Zm4.128 2.249a.133.133 0 0 0 .25 0l2.54-6.95A.133.133 0 0 0 18.056 6h-1.62a.266.266 0 0 0-.25.175l-1.635 4.474a.265.265 0 0 0 0 .182l.84 2.298Zm-3.193-6.956A.264.264 0 0 0 11.95 6h-1.625a.266.266 0 0 0-.25.175L5.82 17.822a.133.133 0 0 0 .125.178h1.62c.111 0 .211-.07.25-.175l3.258-8.917a.067.067 0 0 1 .126 0l3.259 8.917a.266.266 0 0 0 .25.175h1.619a.133.133 0 0 0 .125-.178L12.198 6.173ZM20.708 6h-1.62a.266.266 0 0 0-.25.175l-2.961 8.102a.265.265 0 0 0 0 .182l.84 2.298a.133.133 0 0 0 .25 0l2.93-8.021.935-2.558A.133.133 0 0 0 20.707 6Z" fill="#EF8220" fillRule="nonzero" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <g fill="none" fillRule="evenodd">{t4}{t5}</g>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== className || $[13] !== rest || $[14] !== t2 || $[15] !== t6) {
    t7 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[12] = className;
    $[13] = rest;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export const ArbitrumNovaLogoCircleMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0ZM9.293 6H7.674a.266.266 0 0 0-.25.175L3.168 17.822a.133.133 0 0 0 .125.178h1.62c.111 0 .21-.07.25-.175L9.417 6.178A.133.133 0 0 0 9.293 6Zm2.657 0h-1.625a.266.266 0 0 0-.25.175L5.82 17.822a.133.133 0 0 0 .125.178h1.62c.111 0 .211-.07.25-.175l3.258-8.917a.067.067 0 0 1 .126 0l3.259 8.917a.266.266 0 0 0 .25.175h1.619a.133.133 0 0 0 .125-.178L12.198 6.173A.264.264 0 0 0 11.95 6Zm-.937 4.88-.84 2.298a.265.265 0 0 0 0 .182l1.632 4.465a.266.266 0 0 0 .25.175h1.62a.133.133 0 0 0 .125-.178l-2.537-6.942a.133.133 0 0 0-.25 0ZM20.707 6h-1.62a.266.266 0 0 0-.25.175l-2.96 8.102a.265.265 0 0 0 0 .182l.84 2.298a.133.133 0 0 0 .25 0l2.93-8.021.935-2.558A.133.133 0 0 0 20.707 6Zm-2.651 0h-1.62a.266.266 0 0 0-.25.175l-1.635 4.474a.265.265 0 0 0 0 .182l.84 2.298a.133.133 0 0 0 .25 0l2.54-6.95A.133.133 0 0 0 18.056 6Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};